import { render, staticRenderFns } from "./AppSettingsModal.vue?vue&type=template&id=1135b0a5&"
import script from "./AppSettingsModal.vue?vue&type=script&lang=js&"
export * from "./AppSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsModal.vue?vue&type=style&index=0&id=1135b0a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports